import { useSyncExternalStore } from 'react'

import {
  getIsGleapVisible,
  subscribeToGleapVisibility,
} from '@/integrations/gleap'

const getServerSnapshot = (): boolean => false

export const useIsGleapVisible = (): boolean =>
  useSyncExternalStore(
    subscribeToGleapVisibility,
    getIsGleapVisible,
    getServerSnapshot,
  )
